/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { rulesBasedSoap } from '@/lib/localLLM';

export const SCHEMA_CACHE_KEY = 'voice_diary_schema';

export const emptyFromSchema = (fields = []) => {
  const out = {};
  fields.forEach((f) => { out[f.key] = f.type === 'list' ? [] : ''; });
  return out;
};

export const hasContent = (structured = {}) => Object.values(structured).some((v) =>
  Array.isArray(v) ? v.length > 0 : (typeof v === 'string' ? v.trim().length > 0 : Boolean(v))
);

/** Fallback offline: mappa la trascrizione sui campi dello schema con il motore a regole. */
export const offlineStructure = (transcript, fields) => {
  const soap = rulesBasedSoap(transcript);
  const out = emptyFromSchema(fields);
  const keys = fields.map((f) => f.key);
  const put = (candidates, val) => {
    const k = keys.find((kk) => candidates.some((c) => kk.toLowerCase().includes(c)));
    if (k && val) out[k] = Array.isArray(out[k]) ? [val] : val;
  };
  put(['sintom', 'subject', 'riferit', 'osservaz', 'note'], soap.subjective);
  put(['vital', 'parametr', 'object', 'obiett'], soap.objective);
  put(['valut', 'assess'], soap.assessment);
  put(['piano', 'plan', 'interven', 'azion'], soap.plan);
  if (!hasContent(out) && keys[0]) out[keys[0]] = Array.isArray(out[keys[0]]) ? [transcript] : transcript;
  return out;
};
